import { auth } from "@/api/chatbot";
import { getCsrfToken } from "@/api/chatbot";
import router from "@/router";
import store from "@/store";
import { getCookie, getPageTitle, historyMessageParse, isFunction, lazyLoadHistory, setCookie, urlSafeBase64Encode } from ".";
import { isIgnore } from ".";
import { isEmpty } from ".";
import { getChatHistory } from "@/api/chatbot";
import WeixinInit from "@/utils/weixin";

// 导航守卫
router.beforeEach(async (to, from, next) => {
    if (process.env.VUE_APP_LXA_UPLOADING.toLowerCase() == 'true') {
        window.location.href = "/maintenance.html"
        return
    }

    from
    store.commit('set_pageLoding', true); // 页面加载中
    // set page title
    document.title = getPageTitle(to.meta.title);

    // 验证CSRF token
    let csrfToken = getCookie('csrftoken'); // 不能使用csrftoken
    if (!csrfToken) {
        try {
            const res = await getCsrfToken();
            csrfToken = res.data.csrfToken
            setCookie('csrftoken', csrfToken)
        } catch (e) {
            console.log(e);
            alert('系统错误，请联系网站运维人员。')
            next('/404')
        }
    }
    // eslint-disable-next-line no-debugger
    await new WeixinInit().init()

    // 判断是否需要验证权限
    const whiteList = [];
    if (!whiteList.includes(to.path) && to.meta.auth) {
        const test = process.env.VUE_APP_TEST == 'true'; // 测试环境
        // 验证是否有权限访问
        if (test || isEmpty(store.state.token)) {
            const ticket = to.query.ticket;
            const localDomain = process.env.VUE_APP_LOCAL_DOMAIN; // 本地域名
            if (!ticket) {
                const oauthDomain = process.env.VUE_APP_OAUTH_DOMAIN; // Oauth域名
                const teamId = process.env.VUE_APP_DXY_TEAMID; // 团队id
                const redirectUrl = `${localDomain}/#${to.path}?ticket=`; // oauth验证后的重定向地址
                const redirectUrlEncoded = urlSafeBase64Encode(redirectUrl); // 将重定向地址进行base64编码
                const oauthUrl = `${oauthDomain}/wechatClient/wechat-oauth/get/${teamId}/${redirectUrlEncoded}`;
                // const oauthUrl = `${oauthDomain}/japi/weixin/oauth/ticket/${teamId}/${redirectUrlEncoded}`;
                window.location.href = oauthUrl;
                return
            } else {
                const res = await auth(ticket);
                if (res.code !== 200) {
                    store.commit('clear_all');
                    // // 最多连续刷新3次页面
                    // if (store.state.refreshNum < 3) {
                    //     store.commit('set_refreshNum', store.state.refreshNum + 1);
                    //     window.location.href = localDomain;
                    // }
                    // store.commit('set_refreshNum', 0);
                    store.commit('set_registry', false);
                    store.commit('set_pageLoding', false); // 页面完成
                    next(); // 过
                    return
                } else {
                    const { simuid, token, patientId, registry } = res.data;
                    store.commit('set_simuid', simuid);
                    store.commit('set_patientId', patientId);
                    store.commit('set_registry', registry);
                    store.commit('set_token', token);
                }
            }
        }

        // 聊天记录的获取
        const history = await getChatHistory(1);
        if (history.code !== 200) return // 如果获取失败，则不进入页面
        if (history.data.totalPage <= store.state.page) store.commit('set_page', 0);
        for (const item of history.data.list.reverse()) {
            if (!isIgnore(item.user_input)) {
                await historyMessageParse(item);
            }
        }
        // 添加聊天记录懒加载
        lazyLoadHistory();
    }

    store.commit('set_pageLoding', false); // 页面完成
    next(); // 过
});

router.afterEach(() => { });

// 下滑事件设定
window.ontouchstart = function (event) {
    const touch = event.touches[0];
    const { screenY } = touch;
    const el = document.querySelector('#el-main');
    window.toucheProcess = {
        isTop: el.scrollTop == 0,
        start: screenY,
    }
}
window.ontouchmove = function (event) {
    const touch = event.touches[0];
    const { screenY } = touch;
    window.toucheProcess.end = screenY;
}
window.ontouchend = function () {
    const { start, end, isTop } = window.toucheProcess;
    if (end - start > 100) {
        if (isTop) {
            if (isFunction(window.touchGlide)) window.touchGlide();
        }
    }
}